import React, {Component} from 'react';
import Users from './Transactions/Users';
import Transactions from './Transactions/Transactions';

const TABS = {
    USER: 0,
    TRANSACTION: 1
}

class Eber extends Component {
    state = {
        loading: true,
        tabs: TABS.TRANSACTION
    };

    changeTab = (tab) => {
        this.setState({
            tabs: tab
        })
    }
    
    render() {
        const tab = this.state.tabs;

        let content = null;
        switch(tab) {
            case TABS.USER:
                content = (
                    <Users {...this.props}></Users>
                );
                break;
            case TABS.TRANSACTION:
                content = (
                    <Transactions  {...this.props}></Transactions>
                );
                break;
        }

        return (
            <div className="Eber col-md-12 col-lg-12 col-xs-12">
                <div className="box">
                    <div className="box-body">
                        <div className="col-md-12">
                            <ul className="nav nav-tabs">
                                <li><a className={tab === TABS.TRANSACTION ? "active": ""} onClick={() => this.changeTab(TABS.TRANSACTION)}>Points Transactions</a></li>
                                <li><a className={tab === TABS.USER ? "active": ""} onClick={() => this.changeTab(TABS.USER)}>Users Transactions</a></li>
                            </ul>
                        </div>
                        <div className="col-md-12">
                            <br></br>
                            <div className="tab-content">
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Eber;